__turbopack_context__.v({
  "accountActions": "SxtfTG_accountActions",
  "authActionsContainer": "SxtfTG_authActionsContainer",
  "companySignUp": "SxtfTG_companySignUp",
  "container": "SxtfTG_container",
  "contentContainer": "SxtfTG_contentContainer",
  "footerContainer": "SxtfTG_footerContainer",
  "footerItem": "SxtfTG_footerItem",
  "headerContainer": "SxtfTG_headerContainer",
  "isDrawerVisible": "SxtfTG_isDrawerVisible",
  "isOpen": "SxtfTG_isOpen",
  "navigationActions": "SxtfTG_navigationActions",
  "userInfoContainer": "SxtfTG_userInfoContainer",
  "userMetaContainer": "SxtfTG_userMetaContainer",
});
